export default {
  data() {
    return {
      currencyCode: '',
    };
  },
  computed: {
    currencyLabel() {
      return this.getCurrencyLabel(this.currencyCode);
    },
  },
  methods: {
    getCurrencyLabel(code) {
      if (!code) {
        return '';
      }

      const currency = this.$store.state.misc.currencies.find(((el) => el.code === code));

      return currency?.symbol || `${code} `;
    },
    formatMetric(metric, currencyLabel = this.currencyLabel) {
      if (!currencyLabel) {
        return metric;
      }

      const { title, title_short, ...rest } = metric;

      return {
        ...rest,
        title: title.replace(/, \$|, {{ currencyCode }}/, `, ${currencyLabel}`),
        title_short: title.replace(/, \$|, {{ currencyCode }}/, `, ${currencyLabel}`),
      };
    },
  },
};
